export const DEVICE_SUBTYPES = {
  ANC_PLUS: 'anc+',
  DATALOG_PLUS: 'datalog+',
  ASTRO_LUM: 'astro_lum',
} as const;

export type DeviceSubType = typeof DEVICE_SUBTYPES[keyof typeof DEVICE_SUBTYPES];

export function normalizeDeviceSubType(value: unknown): string {
  return String(value || '').trim().toLowerCase();
}

export function isAstroLumDevice(device: { sub_type?: unknown; serial?: unknown } | null | undefined): boolean {
  if (!device) return false;
  const subType = normalizeDeviceSubType(device.sub_type);
  const serial = String(device.serial || '').toUpperCase();
  return subType === DEVICE_SUBTYPES.ASTRO_LUM || serial.startsWith('M1');
}

export function isAncPlusDevice(device: { sub_type?: unknown; serial?: unknown } | null | undefined): boolean {
  if (!device) return false;
  const subType = normalizeDeviceSubType(device.sub_type);
  const serial = String(device.serial || '').toUpperCase();
  return subType === DEVICE_SUBTYPES.ANC_PLUS || serial.startsWith('A2');
}

export function isDatalogPlusDevice(device: { sub_type?: unknown; serial?: unknown } | null | undefined): boolean {
  if (!device) return false;
  const subType = normalizeDeviceSubType(device.sub_type);
  const serial = String(device.serial || '').toUpperCase();
  return subType === DEVICE_SUBTYPES.DATALOG_PLUS || serial.startsWith('D2');
}

/** Una salida en Astro Uno (A1) y Datalog (D1). El resto tiene dos. */
export function getRelayOutputCount(serial: unknown): number {
  const value = String(serial || '').toUpperCase();
  return value.startsWith('A1') || value.startsWith('D1') ? 1 : 2;
}

/** Dispositivos con programación relay y histórico de canales (ANC+, Datalog+, Astrolum). */
export function isRelaySchedulerDevice(device: { sub_type?: unknown; serial?: unknown } | null | undefined): boolean {
  return isAncPlusDevice(device) || isDatalogPlusDevice(device) || isAstroLumDevice(device);
}

export function isRelaySchedulerSerial(serial: unknown): boolean {
  const value = String(serial || '').toUpperCase();
  return value.startsWith('A2') || value.startsWith('D2') || value.startsWith('M1');
}

/** Familia ANC: comparten ajustes de dispositivo y programación astronómica. */
export function isAncFamilyDevice(device: { sub_type?: unknown; serial?: unknown } | null | undefined): boolean {
  return isAncPlusDevice(device) || isAstroLumDevice(device);
}

function orbisDeviceImage(fileName: string): string {
  return `assets/img/orbis/${fileName}`;
}

export function getRelayDeviceImage(serial: unknown, subType?: unknown): string {
  const serialValue = String(serial || '').toUpperCase();

  if ( serialValue.startsWith('XLUM')) {
    return orbisDeviceImage('xeolum+_rec.png');
  }
  if (serialValue.startsWith('M1')) {
    return orbisDeviceImage('astroMCB_rec.png');
  }
  // ANC+ y Datalog+ comparten icono
  return orbisDeviceImage('anc+_rec.png');
}
